import { render, staticRenderFns } from "./ModifsPermanentes.vue?vue&type=template&id=80cac240&scoped=true"
import script from "./ModifsPermanentes.vue?vue&type=script&lang=js"
export * from "./ModifsPermanentes.vue?vue&type=script&lang=js"
import style0 from "./ModifsPermanentes.vue?vue&type=style&index=0&id=80cac240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cac240",
  null
  
)

export default component.exports